import React, { useState } from "react";
import {
  Modal,
  Box,
  Typography,
  Button,
  TextField,
  Autocomplete,
} from "@mui/material";
import { useTranslation } from "react-i18next";
import ImgAllergyModal from "../../../../../assets/Images/CarePlan3.jpg";
import allergiesDataJson from '../../../../../utils/Apis/ApisJson/allergies.json';

export default function AddAllergyModal({ open, onClose, onSave }) {
  const { t } = useTranslation();
  const [selectedAllergy, setSelectedAllergy] = useState(null);

  const allergyOptions = allergiesDataJson.map((allergy) => ({
    label: allergy.allergy,
  }));

  const handleSave = () => {
    if (selectedAllergy) {
      onSave({
        id: Date.now(),
        date: new Date().toLocaleDateString(),
        name: selectedAllergy.label,
        status: "Activo",
      });
      onClose();
      setSelectedAllergy(null);
    }
  };

  return (
    <Modal open={open} onClose={onClose}>
      <Box
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          width: 450,
          bgcolor: "white",
          boxShadow: 24,
          p: 4,
          borderRadius: 2,
          textAlign: "center",
        }}
      >
        <Typography
          variant="h5"
          sx={{
            fontWeight: "bold",
            color: "#085394",
            mb: 2,
            textTransform: "uppercase",
          }}
        >
          {t("CarePlan.allergy.modal.title")}
        </Typography>

        <Autocomplete
          options={allergyOptions}
          getOptionLabel={(option) => option.label}
          value={selectedAllergy}
          onChange={(event, newValue) => setSelectedAllergy(newValue)}
          renderInput={(params) => (
            <TextField
              {...params}
              label={t("CarePlan.allergy.modal.search")}
              variant="outlined"
              fullWidth
              sx={{ mb: 2 }}
            />
          )}
        />

        <Box sx={{ display: "flex", justifyContent: "center", mb: 2 }}>
          <img
            src={ImgAllergyModal}
            alt="Alergia"
            style={{
              width: "80%",
              maxWidth: "300px",
              opacity: 0.7,
              borderRadius: "8px",
            }}
          />
        </Box>

        <Button
          variant="contained"
          color="success"
          fullWidth
          onClick={handleSave}
          disabled={!selectedAllergy}
        >
          {t("common.save")}
        </Button>
      </Box>
    </Modal>
  );
}
